<ng-container *ifScreenSize="screenType.Mobile">
  <div class="page-header" [ngClass]="{ 'hide-footer': !showFooter, season: season, premium: premium, sgb: sgb }">
    <div class="d-flex align-items-center">
      <div class="banner-name">
        <a (click)="goBack()" class="btn back-btn px-0">
          <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
        </a>
        <ng-container *ngIf="isHomePage">
          <h4 class="mb-0" [ngClass]="{ 'text-title-center': !showQr }">
            {{ pageTitle | uppercase }}
          </h4>
        </ng-container>
        <ng-container *ngIf="!isHomePage">
          <h4 class="mb-0" [ngClass]="{ 'text-title-center': !showQr }">
            {{ pageTitle | translate | uppercase }}
          </h4>
        </ng-container>
      </div>
      <div class="ms-auto d-flex align-items-center widget-details">
        <button *ngIf="showQr" class="qrcode-btn bg-glass" (click)="gotoWallet()">
          <span class="icon material-icons material-mobile-nav">qr_code_2</span>
        </button>
      </div>
    </div>
    <div class="footer"></div>
  </div>
</ng-container>
